import { createStoreSelector } from "../selectors";
export const selectCard = (state) => createStoreSelector(state, 'card')(state);
//# sourceMappingURL=card.selectors.js.map